import { ReferralsApi } from "@/api/referrals";
import { User } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useNotify, useRedirect } from "react-admin";

export const useGetReferralUser = (id: User["id"]) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.REFERRAL_USER, id],
    queryFn: () => ReferralsApi.getReferralUser({ referralId: id }),
    enabled: !!id,
  });

  if (isError) {
    notify(error, { type: "error" });
    redirect("list");
  }

  return { referral: data, isReferralLoading: isPending };
};
